import { useMemo } from 'react';

import { Box, Flex, Text } from '@opendoor/bricks/core';

interface IProps {
  questionKey: string;
}

type TitleSubTitleMap = Record<string, { title: string; subtitle: string }>;

const titleAndSubtitleMap: TitleSubTitleMap = {
  'seller-inform': {
    title: 'First, tell us a bit about you and your situation',
    subtitle: 'This helps us identify how we can best help you sell your home.',
  },
  'home-inform': {
    title: "Looking good! Now, let's learn more about your home",
    subtitle: 'This helps us understand how to price your home.',
  },
};
const InformPage = ({ questionKey }: IProps) => {
  const copy = useMemo(() => {
    return titleAndSubtitleMap[questionKey];
  }, [questionKey]);
  return (
    <Flex
      mt={[0, null, -10]}
      flexDirection="column"
      justifyContent="center"
      gridGap={4}
      height="calc(100dvh - 224px)"
      textAlign="left"
      maxWidth={['100%', null, '560px']}
    >
      <Box>
        <Text
          fontWeight="medium"
          letterSpacing={['-1.4']}
          mb="5"
          mt="7"
          fontSize={['24px', null, '32px']}
          lineHeight={['112', null, '110']}
        >
          {copy.title}
        </Text>
        <Text color="neutrals90" maxWidth="560px" fontSize="18px" lineHeight={'130'}>
          {copy.subtitle}
        </Text>
      </Box>
    </Flex>
  );
};

export default InformPage;
